module.exports = __webpack_public_path__ + "public/images/heart-icon.635ab99b80395b2844980945d62e2cea.png";